import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useDidaiStore = defineStore('didiai', () => {
  // State
  const isPanelOpen = ref(false)
  const isPanelCollapsed = ref(false)
  const messages = ref([])
  const isLoading = ref(false)

  // Actions
  function togglePanel() {
    if (isPanelOpen.value && !isPanelCollapsed.value) {
      // Currently open -> collapse
      isPanelCollapsed.value = true
    } else if (isPanelOpen.value && isPanelCollapsed.value) {
      // Currently collapsed -> expand
      isPanelCollapsed.value = false
    } else {
      // Currently closed -> open
      isPanelOpen.value = true
      isPanelCollapsed.value = false
    }
  }

  function openPanel() {
    isPanelOpen.value = true
    isPanelCollapsed.value = false
  }

  function closePanel() {
    isPanelOpen.value = false
    isPanelCollapsed.value = false
  }

  function addMessage(message) {
    messages.value.push(message)
  }

  function clearMessages() {
    messages.value = []
  }

  function setLoading(loading) {
    isLoading.value = loading
  }

  // Initialize with welcome message
  function initializeChat() {
    if (messages.value.length === 0) {
      addMessage({
        type: 'ai',
        text: 'Hello! I\'m **DiDiAi**, your specialized construction data analyst. I can help you analyze:\n\n🏗️ **Cost Analysis** - PSF costs, budget variance, escalation trends\n👥 **Company Performance** - Contractor rankings, client velocity, collaborations\n📊 **Market Intelligence** - Building premiums, scope analysis, multi-phase tracking\n\nTry one of the sample questions below, or ask me anything about your construction data!',
        timestamp: new Date().toLocaleTimeString()
      })
    }
  }

  return {
    // State
    isPanelOpen,
    isPanelCollapsed,
    messages,
    isLoading,
    
    // Actions
    togglePanel,
    openPanel,
    closePanel,
    addMessage,
    clearMessages,
    setLoading,
    initializeChat
  }
})